<div class="breadcrumb-bar">
     <app-breadcrumb></app-breadcrumb>
</div>
<div class="container">
     <div class="container-chart">
          <label class="ch-title">{{chartTitle}}</label>
          <div class="chart" *ngIf="chartResponseData$ | async as chartResponseData">
               <p-chart 
               id=pieChart
               type="pie" 
               [data]="chartData" 
               [options]="toggleThemeOptions()"
               width="100%"
               height="300px"
               />
          </div>
          @if (timeBySeat) {
               <div class="ch-footer">Tap on a wedge to see the flight time for each seat.  Tap on the Legend label to omit that wedge.</div>
          }
          @else {
               <div class="ch-footer">Tap on a wedge to see the flight time for each aircraft type vairant.  Tap on the Legend label to omit that wedge.</div>

          }
          <div class="card">
               <div class="row">
                    @if(timeBySeat && timeBySeat.data.length > 0) {
                    <div class="column">
                         <div class="label" *ngFor="let item of timeBySeat.labels">
                              <div>{{seatName(item)}}</div>
                         </div>
                    </div>
                    <div class="column">
                         <div class="data" *ngFor="let item of timeBySeat.data">
                              <div>{{item | number: '1.1-1'}} hrs</div>
                         </div>
                    </div>
                    }
                    @else if(timeByAircraft && timeByAircraft.data.length > 0) {
                    <div class="column">
                         <div class="label" *ngFor="let item of timeByAircraft.labels">
                              @if (item === 'NA') {
                                   <div>{{item}}*</div>
                              }
                              @else {
                                   <div>{{item}}</div>
                              }
                         </div>
                    </div>
                    <div class="column">
                         <div class="data" *ngFor="let item of timeByAircraft.data">
                              <div>{{item | number: '1.1-1'}} hrs</div>
                         </div>
                    </div>
                    }
                    @else {
                    <div class="column">
                         <div class="label">
                              <div>N/A</div>
                         </div>
                    </div>
                    <div class="column">
                         <div class="data">
                              <div>0.0 hrs</div>
                         </div>
                    </div>
                    }
               </div>
               @if (timeByAircraft) {
                    <small class="ch-footer">* NA indicates that the aircraft type is unknown.</small>
               }
          </div>
     </div>
</div>